import { 
  fetchStore,
  fetchUpdateStoreFields, // 2023
} from '../../utils/fetchData';
// Actions
import { 
  getStoreUpdate,
} from '../slices/account';
// helpers
import { getJWTstorage } from '../../utils/jwt'
// import { 
//   IMPLEMENTATION_TEMPLATE
// } from '../../utils/levar_data';
import { updateAllStoresVariantsImplementation } from '../../utils/fetchDataGraphQL';


// **************************************************************************
// Connects Updates implementation on levar_ecommerce_stores
// Input: 
//    implementationDataToUpdate => implementation data, 
// **************************************************************************
export function setUpdateEcommStoreImplementation({ implementationDataToUpdate }) {
  return async (dispatch, getState) => {
    try {
      const { account: { user, store }, admin } = getState();
      const jwt = getJWTstorage(admin, user.uuid);

      // console.log('implementationDataToUpdatebefore', implementationDataToUpdate)

      if (implementationDataToUpdate.asset_theme === true) {
        implementationDataToUpdate.asset_theme = 'levar_player';
      } else if (implementationDataToUpdate.asset_theme === '') {
        implementationDataToUpdate.asset_theme = 'RESET';
      }

      // console.log('implementationDataToUpdateafter', implementationDataToUpdate)

      // Stripping out ar_experience_type from saving implementationt
      // eslint-disable-next-line camelcase
      const { ...implementationDataToKeep } = implementationDataToUpdate;
      // console.log('ar_experience_type', ar_experience_type)

      const dataToUpdate = {
        store_id: store.store_id,
        implementations: {
          ...implementationDataToKeep
        }
      };
      console.log('dataToUpdate', dataToUpdate)
      await fetchUpdateStoreFields(dataToUpdate, jwt, admin.adminStatus);

      const updatedStore = await fetchStore(store.store_id, jwt, false);
      dispatch(getStoreUpdate(updatedStore.search_response));
      
    } catch(error) {
      console.error('Error updating store implementation:', error);
      throw error; // Re-throw to handle in component
    }
  }
};


// **************************************************************************
// Updates all stores variants with the same implementation
// 2025
// **************************************************************************
export function setUpdateAllStoresVariantsImplementation() {
  return async (dispatch, getState) => {
    try {
      const { account: { user, store }, admin } = getState();
      const jwt = getJWTstorage(admin, user.uuid);

      // Format implementation data
      const implementations = store?.implementations || {};

      // console.log('Syncing store implementations:', implementations);
      await updateAllStoresVariantsImplementation(store.store_id, implementations);

      const updatedStore = await fetchStore(store.store_id, jwt, false);
      dispatch(getStoreUpdate(updatedStore.search_response));
      
    } catch(error) {
      console.error('Error updating store implementation:', error);
      throw error; // Re-throw to handle in component
    }
  }
};


export function setUpdateEcommStoreFields({ fieldsToUpdate, storeID, platform }) {
  return async (dispatch, getState) => {
    try {
      const { account: { user, store }, admin } = getState();
      const jwt = getJWTstorage(admin, user.uuid);

      const storeIdentifier = storeID ?? store.store_id
      
      // Create a clean copy of fieldsToUpdate without billing_on for Shopify stores
      const cleanFieldsToUpdate = { ...fieldsToUpdate };
      if (platform === 'shopify' && fieldsToUpdate.billing_on) {
        console.log("Removing billing_on from cleanFieldsToUpdate")
        delete cleanFieldsToUpdate.billing_on;
      }
      
      const dataToUpdate = {
        store_id: storeIdentifier,
        ...(platform === 'shopify' && fieldsToUpdate.billing_on && { 
          shopify_billing_on: fieldsToUpdate.billing_on.toISOString().split('T')[0] 
        }),
        ...cleanFieldsToUpdate
      };

      console.log("dataToUpdate after construction:", dataToUpdate)

      await fetchUpdateStoreFields(dataToUpdate, jwt, admin.adminStatus);

      // UPDATE STORE REDUX
      const updatedStore = await fetchStore(storeIdentifier, jwt, false);

      if(storeID) return // When in admin dashboard dont update redux
      dispatch(getStoreUpdate(updatedStore.search_response));
      
    } catch(error) {
      console.log('error on setUpdateEcommStoreFields thunk', error);
    }
  }
};
